import { Instagram, MessageCircle, Mail, MapPin } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="pt-16 pb-8" style={{ background: "#1F2937" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img src="/logo-runforrett.svg" alt="Run for Rett Logo" className="h-10 w-auto brightness-0 invert" />
            </div>
            <p className="text-sm leading-relaxed" style={{ color: "rgba(255,255,255,0.6)" }}>
              Laufen für eine Zukunft ohne Rett-Syndrom. Gemeinsam laufen. Gemeinsam Hoffnung schenken.
            </p>
          </div>

          {/* Kontakt */}
          <div className="space-y-4">
            <h4 className="font-heading font-bold text-sm text-white uppercase tracking-wider">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" style={{ color: "#7DD4B5" }} />
                <span className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>
                  92331 Parsberg-Herrnried, Deutschland
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" style={{ color: "#7DD4B5" }} />
                <a
                  href="mailto:info@runforrett.de"
                  data-testid="footer-email-link"
                  className="text-sm hover:text-white transition-colors"
                  style={{ color: "rgba(255,255,255,0.6)" }}
                >
                  info@runforrett.de
                </a>
              </div>
            </div>
            {/* Social */}
            <div className="flex items-center gap-3 pt-2">
              <a
                data-testid="social-instagram"
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center hover:scale-110 transition-transform"
                style={{ background: "rgba(149,225,187,0.15)" }}
              >
                <Instagram className="w-5 h-5" style={{ color: "#7DD4B5" }} />
              </a>
              <a
                data-testid="social-whatsapp"
                href="https://wa.me/?text=Run%20for%20Rett%20-%20Laufen%20f%C3%BCr%20eine%20Zukunft%20ohne%20Rett-Syndrom!"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center hover:scale-110 transition-transform"
                style={{ background: "rgba(149,225,187,0.15)" }}
              >
                <MessageCircle className="w-5 h-5" style={{ color: "#7DD4B5" }} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="font-heading font-bold text-sm text-white uppercase tracking-wider">Rechtliches</h4>
            <div className="space-y-2">
              <Link
                to="/impressum"
                data-testid="footer-impressum-link"
                className="block text-sm hover:text-white transition-colors"
                style={{ color: "rgba(255,255,255,0.6)" }}
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                data-testid="footer-datenschutz-link"
                className="block text-sm hover:text-white transition-colors"
                style={{ color: "rgba(255,255,255,0.6)" }}
              >
                Datenschutz
              </Link>
              <a
                href="#"
                className="block text-sm hover:text-white transition-colors"
                style={{ color: "rgba(255,255,255,0.6)" }}
              >
                Barrierefreiheit
              </a>
              <Link
                to="/agb"
                data-testid="footer-agb-link"
                className="block text-sm hover:text-white transition-colors"
                style={{ color: "rgba(255,255,255,0.6)" }}
              >
                AGB
              </Link>
            </div>
          </div>
        </div>

        <Separator className="opacity-10" />

        <div className="pt-6 text-center">
          <p className="text-sm" style={{ color: "rgba(255,255,255,0.4)" }}>
            &copy; {new Date().getFullYear()} Run for Rett – Laufen für eine Zukunft ohne Rett-Syndrom.
          </p>
        </div>
      </div>
    </footer>
  );
}
